module.exports = __webpack_public_path__ + "static/media/Construction.cf0da2a7.svg";